import Axios from "axios";
import {
  SET_LC_DOCUMENT_TYPE_LIST,
  UNSET_LC_DOCUMENT_TYPE_LIST,
} from "@/store/mutation-types";
import { getLcDocumentTypeList, getLcDocumentTypeById, saveLcDocumentType, updateLcDocumentType } from "@/store/api";

const state = {
  lcDocumentTypeList: [],
};

const getters = {
  getLcDocumentTypeList(state) {
    return state.lcDocumentTypeList;
  },
};

const mutations = {
  [SET_LC_DOCUMENT_TYPE_LIST](state, data) {
    state.lcDocumentTypeList = data;
  },
  [UNSET_LC_DOCUMENT_TYPE_LIST](state) {
    state.lcDocumentTypeList = [];
  },
};

const actions = {
  saveUpdateLcDocumentType({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      const url = data.id ? `${updateLcDocumentType}${data.id}` : saveLcDocumentType;
      const method = data.id ? 'put' : 'post';
      const payload = { ...data };
      if (data.id) delete payload.id;
      
      Axios[method](url, payload)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcDocumentTypeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcDocumentTypeList, data)
        .then(function (response) {
          commit("SET_LC_DOCUMENT_TYPE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_DOCUMENT_TYPE_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};